const ImageNotAvailable = ({ label }) => {
  return (
    <div className="image-viewer">
      <p className="image-viewer-title">{label}</p>
      <div className="image-viewer-field empty" style={{ margin: 0 }}>
        <div className="image-viewer-empty-image">
          <img src="/assets/image/no-image-available.png" className="img" />
          <p style={{ color: '#757575', marginTop: 8 }}>Gambar tidak tersedia</p>
        </div>
      </div>
    </div>
  );
};

export default ImageNotAvailable;
